export default __webpack_public_path__ + "static/media/q17_step3.c4cfda65.png";